import React from "react";

const ReadMoreSarah = () => {
  return (
    <div>
      <div>
        <p>
        Sarah provided us with a valuable insight into the regulatory landscape of live biotherapeutic products (LBP) in Europe. 
        She described it as a complex regulatory environment that involves several key aspects:
        </p>
      <p className="mb-2">
- Adhering to the established guiding principles outlined in existing regulatory guidelines.
<br></br>
- Assessing the comparability of approaches used for other therapeutic products and customizing them as necessary.
<br></br>
- Effectively utilizing the flexibility within the stipulated requirements to devise alternative strategies.
<br></br>
- Engaging in communication with regulatory agencies and gaining their support for the proposed development pathway.
</p>
      <p className="mb-2">
Our initial query concerned the security standards that our probiotic product would need to meet and the feasibility 
of obtaining approval in the near future.
</p>
      <p className="mb-2">
In Europe, the European Medicines Agency (EMA) holds the authority for approval, while in Switzerland it's Swissmedic that 
oversees the approval process. Typically, when approval is granted in Europe, Swissmedic recognizes and approves the 
European dossier through an independent evaluation. For the United States, the Food and Drug Administration (FDA) is 
responsible for granting approval.
</p>
      <p className="mb-2">
For our LBP to be approved she underlined the necessity of proving its safety, even if the bacteria is "commensal"
(naturally present in the gut). For the safety she confirmed the importance of the control for the Horizontal Gene Transfer.
But depending on how we will administer it the regulations can vary. In this sense an idea that she gave us was that we 
could integrate it in common foods in the affected areas for regular intake.
</p>
      <p className="mb-2">
Engaging in the review and deliberation of the regulatory documents also highlighted the significance of taking the 
shelf-life into account. This consideration is vital to ensure that the product remains suitable for all stages of the 
distribution process as well as for end-users.
</p>
      <p className="mb-2">
She then directed us to a thesis focusing on the “Évaluation des probiotiques sur le marché oﬀicinal et élaboration d’un 
guide pratique d’aide au conseil sur les probiotiques pour le pharmacien d’oﬀicine” {" "}
          <a href="#reference3">
            {" "}
            <sup>3</sup>{" "}
          </a>.
From the thesis we learnt that a report from a Joint FAO/WHO Expert consultation published in 2001 establishes several 
guidelines concerning probiotics and provides us with certain recommendations. 11 experts from 10 countries participated in 
the consultation to assess the scientific evidence available regarding the properties, functionality, benefits, safety, and 
characteristics of probiotics. Initially, the consultation focused on strains available as probiotics in foods. However, 
even though the Consultation did not specifically address issues related to genetically modified organisms (GMOs), the 
concepts and principles outlined in this report are also applicable to all probiotics. 
</p>
      <p className="mb-2">
The consultation suggested utilizing the following three guidelines to assess the properties of probiotics.
It emphasizes that for the oral use of probiotic microorganisms, it is necessary 
to ensure:

</p>
      <p className="mb-2">
- Their ability to survive passage through the digestive tract. This implies that they must be resistant to gastric 
juices or must be administered in a vehicle that enables them to survive passage through the stomach.
</p>
      <p className="mb-2">
- Their ability to proliferate in the intestine. This implies that they must be able to grow in the presence of bile 
under conditions found in the intestines or must be administered in a vehicle that allows them to survive exposure to bile.
According to the consultation, these two conditions are primarily found in Gram-positive bacteria, especially in the 
<i>Lactobacillus</i> and <i>Bifidobacterium genera</i>.

The three guidelines are as follows:
</p>
      <p className="mb-2">

1. Select probiotic strains for human use.
<br></br>
2. Classify and identify individual strains.
<br></br>
3. Define and measure the health benefits of probiotics.
<br></br>

In particular for point 3, depending on the proposed health benefit, certain tests need to be conducted, such as:

- A test assessing the probiotic's tolerance to acid and bile.
<br></br>
- A test evaluating the production of antimicrobials.
<br></br>
- A test assessing the probiotic's ability to adhere to human intestinal cells.
<br></br>
</p>
      <p className="mb-2">
In conclusion, our discussion with Sarah Naili provided us with valuable insights into the upcoming actions required for 
progressing in our projects through clinical trials and hopefully achieving one day clinical approval.

        </p>
      </div>
    </div>
  );
};

export default ReadMoreSarah;
